export enum BookServiceSteps {
  SCHEDULE = 'schedule',
  OPTIONS = 'options',
  SELECT_LOCATION = 'select-location',
  CHECKOUT = 'checkout',
  ADD_ONS = 'add-ons',
  ADDITIONAL_INFO = 'additional-info',
}
